import React, { useEffect, useState } from "react";
import { Box, Button, Divider, FormControl, IconButton, InputLabel, MenuItem, Modal, Select, TextField, Typography, CircularProgress} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CatalogoPerfil, useGetCatalogoPerfiles, } from "../../../hooks/catalogosPerfiles/getCatalogoPerfiles";
import { useUpdateUserAdmin } from "../../../hooks/AdministracionUsuarios/adminUsuarios/updateUserAdmin";
import { sanitizarNombre, sanitizarCorreo, validarNombre, validarCorreo, } from "../../../utils/sanitizar";
interface UsuarioEditar {
    id: number;
    nombre: string;
    correo: string;
    idPerfil: number;
    estatus: number;
}

interface UpdateAdminUserProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => Promise<void> | void;
    usuario: UsuarioEditar | null;
}

const UpdateAdminUser: React.FC<UpdateAdminUserProps> = ({
    open,
    onClose,
    onSuccess,
    usuario,
}) => {

    const { perfiles, obtenerCatalogoPerfiles } =
        useGetCatalogoPerfiles();

    const {
        actualizarUsuario,
        loading,
    } = useUpdateUserAdmin();

    const [nombre, setNombre] = useState("");
    const [correo, setCorreo] = useState("");
    const [idPerfil, setIdPerfil] = useState<number>(0);

    const [errorNombre, setErrorNombre] = useState("");

    const [catalogoListo, setCatalogoListo] = useState(false);
    const [errorCorreo, setErrorCorreo] = useState("");

    // carga de modal y catalogo
    useEffect(() => {

        const cargarInformacion = async () => {

            if (!open || !usuario) return;

            setCatalogoListo(false);

            await obtenerCatalogoPerfiles();

            setNombre(usuario.nombre);
            setCorreo(usuario.correo);
            setIdPerfil(usuario.idPerfil);

            setErrorNombre("");

            setCatalogoListo(true);

        };

        cargarInformacion();

    }, [open, usuario]);

    const cerrarModal = () => {

        limpiarFormulario();

        onClose();

    };

    const guardar = async () => {
        setErrorNombre("");
        if (!validarNombre(nombre)) {
            setErrorNombre("Ingresa un nombre válido.");
            return;
        }

        if (idPerfil === 0) {
            return;
        }

        setErrorCorreo("");

        let existeError = false;

        if (!validarNombre(nombre)) {

            setErrorNombre("Ingresa un nombre válido.");

            existeError = true;

        }

        if (!validarCorreo(correo)) {

            setErrorCorreo("Ingresa un correo electrónico válido.");

            existeError = true;

        }

        if (idPerfil === 0) {
            existeError = true;
        }

        if (existeError) {
            return;
        }

        const response = await actualizarUsuario({

            id: usuario!.id,
            nombre: nombre.trim(),
            idPerfil,

        });

        if (response) {

            await onSuccess?.();

            cerrarModal();

        }

    };

    const limpiarFormulario = () => {
        setNombre("");
        setCorreo("");
        setIdPerfil(0);

        setErrorNombre("");
        setErrorCorreo("");
    };

    if (open && !catalogoListo) {

        return (

            <Modal open={open}>

                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        width: 220,
                        height: 160,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                    }}
                >

                    <CircularProgress />

                    <Typography
                        variant="body2"
                        color="text.secondary"
                    >
                        Cargando información...
                    </Typography>

                </Box>

            </Modal>

        );

    }

    return (

        <Modal
            open={open}
            onClose={cerrarModal}
        >

            <Modal
                open={open}
                onClose={cerrarModal}
            >

                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "90%",
                        maxWidth: 650,
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 3,
                    }}
                >

                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2}
                    >

                        <Typography
                            variant="h6"
                            fontWeight="bold"
                        >
                            Editar Usuario
                        </Typography>

                        <IconButton onClick={cerrarModal}>
                            <CloseIcon />
                        </IconButton>

                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    <Box
                        display="flex"
                        flexDirection="column"
                        gap={3}
                    >

                        <TextField
                            fullWidth
                            label="Nombre"
                            value={nombre}
                            error={Boolean(errorNombre)}
                            helperText={errorNombre}
                            onChange={(e) => {

                                setNombre(
                                    sanitizarNombre(e.target.value)
                                );

                                if (errorNombre) {
                                    setErrorNombre("");
                                }

                            }}
                        />

                        <TextField
                            fullWidth
                            label="Correo electrónico"
                            value={correo}
                            error={Boolean(errorCorreo)}
                            helperText={errorCorreo}
                            onChange={(e) => {

                                const value = sanitizarCorreo(e.target.value);

                                setCorreo(value);

                                if (errorCorreo && validarCorreo(value)) {
                                    setErrorCorreo("");
                                }

                            }}
                            onBlur={() => {

                                if (correo && !validarCorreo(correo)) {

                                    setErrorCorreo(
                                        "Ingresa un correo electrónico válido."
                                    );

                                }

                            }}
                        />

                        <FormControl fullWidth>

                            <InputLabel>
                                Perfil
                            </InputLabel>

                            <Select
                                value={idPerfil}
                                label="Perfil"
                                onChange={(e) =>
                                    setIdPerfil(Number(e.target.value))
                                }
                            >

                                {perfiles.map((perfil: CatalogoPerfil) => (

                                    <MenuItem
                                        key={perfil.id}
                                        value={perfil.id}
                                    >
                                        {perfil.nombre}
                                    </MenuItem>

                                ))}

                            </Select>

                        </FormControl>

                    </Box>

                    <Divider sx={{ my: 3 }} />

                    <Box
                        display="flex"
                        justifyContent="flex-end"
                        gap={2}
                    >

                        <Button
                            variant="contained"
                            onClick={cerrarModal}
                            sx={{
                                bgcolor: "#F70083",
                                color: "#fff",
                                fontWeight: 600,
                                textTransform: "none",
                                borderRadius: 2,
                                px: 3,
                                "&:hover": {
                                    bgcolor: "#D60072",
                                },
                            }}
                        >
                            Cancelar
                        </Button>

                        <Button
                            variant="contained"
                            onClick={guardar}
                            disabled={
                                loading ||
                                !nombre.trim() ||
                                !correo.trim() ||
                                !validarNombre(nombre) ||
                                !validarCorreo(correo) ||
                                idPerfil === 0
                            }
                            sx={{
                                bgcolor: "#2e7d32",
                                color: "#fff",
                                fontWeight: 600,
                                textTransform: "none",
                                borderRadius: 2,
                                px: 3,
                                "&:hover": {
                                    bgcolor: "#1b5e20",
                                },
                            }}
                        >
                            {loading ? "Guardando..." : "Guardar Cambios"}
                        </Button>

                    </Box>

                </Box>

            </Modal>

        </Modal>

    );

};

export default UpdateAdminUser;